import documentVisibility from 'helpers/documentVisibility'

function handleOnVisible() {
	return new Promise(resolve => {
		documentVisibility.onChange(resolve)
	})
}

async function waitForDocumentVisibility() {
	if (!documentVisibility.isHidden()) {
		return true
	}
	await handleOnVisible()
	return true
}

export default waitForDocumentVisibility
